export const countryDialCodes = {
  AF: { name: "Afghanistan", mobileCode: "93" },
  AX: { name: "Aland Islands", mobileCode: "358" },
  AL: { name: "Albania", mobileCode: "355" },
  DZ: { name: "Algeria", mobileCode: "213" },
  AS: { name: "AmericanSamoa", mobileCode: "1684" },
  AD: { name: "Andorra", mobileCode: "376" },
  AO: { name: "Angola", mobileCode: "244" },
  AI: { name: "Anguilla", mobileCode: "1264" },
  AQ: { name: "Antarctica", mobileCode: "672" },
  AG: { name: "Antigua and Barbuda", mobileCode: "1268" },
  AR: { name: "Argentina", mobileCode: "54" },
  AM: { name: "Armenia", mobileCode: "374" },
  AW: { name: "Aruba", mobileCode: "297" },
  AU: { name: "Australia", mobileCode: "61" },
  AT: { name: "Austria", mobileCode: "43" },
  AZ: { name: "Azerbaijan", mobileCode: "994" },
  BS: { name: "Bahamas", mobileCode: "1242" },
  BH: { name: "Bahrain", mobileCode: "973" },
  BD: { name: "Bangladesh", mobileCode: "880" },
  BB: { name: "Barbados", mobileCode: "1246" },
  BY: { name: "Belarus", mobileCode: "375" },
  BE: { name: "Belgium", mobileCode: "32" },
  BZ: { name: "Belize", mobileCode: "501" },
  BJ: { name: "Benin", mobileCode: "229" },
  BM: { name: "Bermuda", mobileCode: "1441" },
  BT: { name: "Bhutan", mobileCode: "975" },
  BO: { name: "Bolivia, Plurinational State of", mobileCode: "591" },
  BA: { name: "Bosnia and Herzegovina", mobileCode: "387" },
  BW: { name: "Botswana", mobileCode: "267" },
  BR: { name: "Brazil", mobileCode: "55" },
  IO: { name: "British Indian Ocean Territory", mobileCode: "246" },
  BN: { name: "Brunei Darussalam", mobileCode: "673" },
  BG: { name: "Bulgaria", mobileCode: "359" },
  BF: { name: "Burkina Faso", mobileCode: "226" },
  BI: { name: "Burundi", mobileCode: "257" },
  KH: { name: "Cambodia", mobileCode: "855" },
  CM: { name: "Cameroon", mobileCode: "237" },
  CA: { name: "Canada", mobileCode: "1" },
  CV: { name: "Cape Verde", mobileCode: "238" },
  KY: { name: "Cayman Islands", mobileCode: "345" },
  CF: { name: "Central African Republic", mobileCode: "236" },
  TD: { name: "Chad", mobileCode: "235" },
  CL: { name: "Chile", mobileCode: "56" },
  CN: { name: "China", mobileCode: "86" },
  CX: { name: "Christmas Island", mobileCode: "61" },
  CC: { name: "Cocos (Keeling) Islands", mobileCode: "61" },
  CO: { name: "Colombia", mobileCode: "57" },
  KM: { name: "Comoros", mobileCode: "269" },
  CG: { name: "Congo", mobileCode: "242" },
  CD: {
    name: "Congo, The Democratic Republic of the Congo",
    mobileCode: "243",
  },
  CK: { name: "Cook Islands", mobileCode: "682" },
  CR: { name: "Costa Rica", mobileCode: "506" },
  CI: { name: "Cote d'Ivoire", mobileCode: "225" },
  HR: { name: "Croatia", mobileCode: "385" },
  CU: { name: "Cuba", mobileCode: "53" },
  CY: { name: "Cyprus", mobileCode: "357" },
  CZ: { name: "Czech Republic", mobileCode: "420" },
  DK: { name: "Denmark", mobileCode: "45" },
  DJ: { name: "Djibouti", mobileCode: "253" },
  DM: { name: "Dominica", mobileCode: "1767" },
  DO: { name: "Dominican Republic", mobileCode: "1849" },
  EC: { name: "Ecuador", mobileCode: "593" },
  EG: { name: "Egypt", mobileCode: "20" },
  SV: { name: "El Salvador", mobileCode: "503" },
  GQ: { name: "Equatorial Guinea", mobileCode: "240" },
  ER: { name: "Eritrea", mobileCode: "291" },
  EE: { name: "Estonia", mobileCode: "372" },
  ET: { name: "Ethiopia", mobileCode: "251" },
  FK: { name: "Falkland Islands (Malvinas)", mobileCode: "500" },
  FO: { name: "Faroe Islands", mobileCode: "298" },
  FJ: { name: "Fiji", mobileCode: "679" },
  FI: { name: "Finland", mobileCode: "358" },
  FR: { name: "France", mobileCode: "33" },
  GF: { name: "French Guiana", mobileCode: "594" },
  PF: { name: "French Polynesia", mobileCode: "689" },
  GA: { name: "Gabon", mobileCode: "241" },
  GM: { name: "Gambia", mobileCode: "220" },
  GE: { name: "Georgia", mobileCode: "995" },
  DE: { name: "Germany", mobileCode: "49" },
  GH: { name: "Ghana", mobileCode: "233" },
  GI: { name: "Gibraltar", mobileCode: "350" },
  GR: { name: "Greece", mobileCode: "30" },
  GL: { name: "Greenland", mobileCode: "299" },
  GD: { name: "Grenada", mobileCode: "1473" },
  GP: { name: "Guadeloupe", mobileCode: "590" },
  GU: { name: "Guam", mobileCode: "1671" },
  GT: { name: "Guatemala", mobileCode: "502" },
  GG: { name: "Guernsey", mobileCode: "44" },
  GN: { name: "Guinea", mobileCode: "224" },
  GW: { name: "Guinea-Bissau", mobileCode: "245" },
  GY: { name: "Guyana", mobileCode: "595" },
  HT: { name: "Haiti", mobileCode: "509" },
  VA: { name: "Holy See (Vatican City State)", mobileCode: "379" },
  HN: { name: "Honduras", mobileCode: "504" },
  HK: { name: "Hong Kong", mobileCode: "852" },
  HU: { name: "Hungary", mobileCode: "36" },
  IS: { name: "Iceland", mobileCode: "354" },
  IN: { name: "India", mobileCode: "91" },
  ID: { name: "Indonesia", mobileCode: "62" },
  IR: { name: "Iran, Islamic Republic of Persian Gulf", mobileCode: "98" },
  IQ: { name: "Iraq", mobileCode: "964" },
  IE: { name: "Ireland", mobileCode: "353" },
  IM: { name: "Isle of Man", mobileCode: "44" },
  IL: { name: "Israel", mobileCode: "972" },
  IT: { name: "Italy", mobileCode: "39" },
  JM: { name: "Jamaica", mobileCode: "1876" },
  JP: { name: "Japan", mobileCode: "81" },
  JE: { name: "Jersey", mobileCode: "44" },
  JO: { name: "Jordan", mobileCode: "962" },
  KZ: { name: "Kazakhstan", mobileCode: "77" },
  KE: { name: "Kenya", mobileCode: "254" },
  KI: { name: "Kiribati", mobileCode: "686" },
  KP: {
    name: "Korea, Democratic People's Republic of Korea",
    mobileCode: "850",
  },
  KR: { name: "Korea, Republic of South Korea", mobileCode: "82" },
  KW: { name: "Kuwait", mobileCode: "965" },
  KG: { name: "Kyrgyzstan", mobileCode: "996" },
  LA: { name: "Laos", mobileCode: "856" },
  LV: { name: "Latvia", mobileCode: "371" },
  LB: { name: "Lebanon", mobileCode: "961" },
  LS: { name: "Lesotho", mobileCode: "266" },
  LR: { name: "Liberia", mobileCode: "231" },
  LY: { name: "Libyan Arab Jamahiriya", mobileCode: "218" },
  LI: { name: "Liechtenstein", mobileCode: "423" },
  LT: { name: "Lithuania", mobileCode: "370" },
  LU: { name: "Luxembourg", mobileCode: "352" },
  MO: { name: "Macao", mobileCode: "853" },
  MK: { name: "Macedonia", mobileCode: "389" },
  MG: { name: "Madagascar", mobileCode: "261" },
  MW: { name: "Malawi", mobileCode: "265" },
  MY: { name: "Malaysia", mobileCode: "60" },
  MV: { name: "Maldives", mobileCode: "960" },
  ML: { name: "Mali", mobileCode: "223" },
  MT: { name: "Malta", mobileCode: "356" },
  MH: { name: "Marshall Islands", mobileCode: "692" },
  MQ: { name: "Martinique", mobileCode: "596" },
  MR: { name: "Mauritania", mobileCode: "222" },
  MU: { name: "Mauritius", mobileCode: "230" },
  YT: { name: "Mayotte", mobileCode: "262" },
  MX: { name: "Mexico", mobileCode: "52" },
  FM: {
    name: "Micronesia, Federated States of Micronesia",
    mobileCode: "691",
  },
  MD: { name: "Moldova", mobileCode: "373" },
  MC: { name: "Monaco", mobileCode: "377" },
  MN: { name: "Mongolia", mobileCode: "976" },
  ME: { name: "Montenegro", mobileCode: "382" },
  MS: { name: "Montserrat", mobileCode: "1664" },
  MA: { name: "Morocco", mobileCode: "212" },
  MZ: { name: "Mozambique", mobileCode: "258" },
  MM: { name: "Myanmar", mobileCode: "95" },
  NA: { name: "Namibia", mobileCode: "264" },
  NR: { name: "Nauru", mobileCode: "674" },
  NP: { name: "Nepal", mobileCode: "977" },
  NL: { name: "Netherlands", mobileCode: "31" },
  AN: { name: "Netherlands Antilles", mobileCode: "599" },
  NC: { name: "New Caledonia", mobileCode: "687" },
  NZ: { name: "New Zealand", mobileCode: "64" },
  NI: { name: "Nicaragua", mobileCode: "505" },
  NE: { name: "Niger", mobileCode: "227" },
  NG: { name: "Nigeria", mobileCode: "234" },
  NU: { name: "Niue", mobileCode: "683" },
  NF: { name: "Norfolk Island", mobileCode: "672" },
  MP: { name: "Northern Mariana Islands", mobileCode: "1670" },
  NO: { name: "Norway", mobileCode: "47" },
  OM: { name: "Oman", mobileCode: "968" },
  PK: { name: "Pakistan", mobileCode: "92" },
  PW: { name: "Palau", mobileCode: "680" },
  PS: { name: "Palestinian Territory, Occupied", mobileCode: "970" },
  PA: { name: "Panama", mobileCode: "507" },
  PG: { name: "Papua New Guinea", mobileCode: "675" },
  PY: { name: "Paraguay", mobileCode: "595" },
  PE: { name: "Peru", mobileCode: "51" },
  PH: { name: "Philippines", mobileCode: "63" },
  PN: { name: "Pitcairn", mobileCode: "872" },
  PL: { name: "Poland", mobileCode: "48" },
  PT: { name: "Portugal", mobileCode: "351" },
  PR: { name: "Puerto Rico", mobileCode: "1939" },
  QA: { name: "Qatar", mobileCode: "974" },
  RO: { name: "Romania", mobileCode: "40" },
  RU: { name: "Russia", mobileCode: "7" },
  RW: { name: "Rwanda", mobileCode: "250" },
  RE: { name: "Reunion", mobileCode: "262" },
  BL: { name: "Saint Barthelemy", mobileCode: "590" },
  SH: {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    mobileCode: "290",
  },
  KN: { name: "Saint Kitts and Nevis", mobileCode: "1869" },
  LC: { name: "Saint Lucia", mobileCode: "1758" },
  MF: { name: "Saint Martin", mobileCode: "590" },
  PM: { name: "Saint Pierre and Miquelon", mobileCode: "508" },
  VC: { name: "Saint Vincent and the Grenadines", mobileCode: "1784" },
  WS: { name: "Samoa", mobileCode: "685" },
  SM: { name: "San Marino", mobileCode: "378" },
  ST: { name: "Sao Tome and Principe", mobileCode: "239" },
  SA: { name: "Saudi Arabia", mobileCode: "966" },
  SN: { name: "Senegal", mobileCode: "221" },
  RS: { name: "Serbia", mobileCode: "381" },
  SC: { name: "Seychelles", mobileCode: "248" },
  SL: { name: "Sierra Leone", mobileCode: "232" },
  SG: { name: "Singapore", mobileCode: "65" },
  SK: { name: "Slovakia", mobileCode: "421" },
  SI: { name: "Slovenia", mobileCode: "386" },
  SB: { name: "Solomon Islands", mobileCode: "677" },
  SO: { name: "Somalia", mobileCode: "252" },
  ZA: { name: "South Africa", mobileCode: "27" },
  SS: { name: "South Sudan", mobileCode: "211" },
  GS: {
    name: "South Georgia and the South Sandwich Islands",
    mobileCode: "500",
  },
  ES: { name: "Spain", mobileCode: "34" },
  LK: { name: "Sri Lanka", mobileCode: "94" },
  SD: { name: "Sudan", mobileCode: "249" },
  SR: { name: "Suriname", mobileCode: "597" },
  SJ: { name: "Svalbard and Jan Mayen", mobileCode: "47" },
  SZ: { name: "Swaziland", mobileCode: "268" },
  SE: { name: "Sweden", mobileCode: "46" },
  CH: { name: "Switzerland", mobileCode: "41" },
  SY: { name: "Syrian Arab Republic", mobileCode: "963" },
  TW: { name: "Taiwan", mobileCode: "886" },
  TJ: { name: "Tajikistan", mobileCode: "992" },
  TZ: { name: "Tanzania, United Republic of Tanzania", mobileCode: "255" },
  TH: { name: "Thailand", mobileCode: "66" },
  TL: { name: "Timor-Leste", mobileCode: "670" },
  TG: { name: "Togo", mobileCode: "228" },
  TK: { name: "Tokelau", mobileCode: "690" },
  TO: { name: "Tonga", mobileCode: "676" },
  TT: { name: "Trinidad and Tobago", mobileCode: "1868" },
  TN: { name: "Tunisia", mobileCode: "216" },
  TR: { name: "Turkey", mobileCode: "90" },
  TM: { name: "Turkmenistan", mobileCode: "993" },
  TC: { name: "Turks and Caicos Islands", mobileCode: "1649" },
  TV: { name: "Tuvalu", mobileCode: "688" },
  UG: { name: "Uganda", mobileCode: "256" },
  UA: { name: "Ukraine", mobileCode: "380" },
  AE: { name: "United Arab Emirates", mobileCode: "971" },
  GB: { name: "United Kingdom", mobileCode: "44" },
  US: { name: "United States", mobileCode: "1" },
  UY: { name: "Uruguay", mobileCode: "598" },
  UZ: { name: "Uzbekistan", mobileCode: "998" },
  VU: { name: "Vanuatu", mobileCode: "678" },
  VE: {
    name: "Venezuela, Bolivarian Republic of Venezuela",
    mobileCode: "58",
  },
  VN: { name: "Vietnam", mobileCode: "84" },
  VG: { name: "Virgin Islands, British", mobileCode: "1284" },
  VI: { name: "Virgin Islands, U.S.", mobileCode: "1340" },
  WF: { name: "Wallis and Futuna", mobileCode: "681" },
  YE: { name: "Yemen", mobileCode: "967" },
  ZM: { name: "Zambia", mobileCode: "260" },
  ZW: { name: "Zimbabwe", mobileCode: "263" },
};

export const INDIAN_IP_COUNTRIES_CODES = [
  { country: "India", code: "+91", countryCode: "IN" },
  ,
  { country: "Nepal", code: "+977", countryCode: "NP" },
  { country: "Bhutan", code: "+975", countryCode: "BT" },
];

export const ALL_COUNTRIES = [
  {country: "India", code: "+91", countryCode:  "IN"},
  {country: "United Arab Emirates", code: "+971", countryCode:  "AE"},
  {country: "Saudi Arabia", code: "+966", countryCode:  "SA"},
  {country: "Kuwait", code: "+965", countryCode:  "KW"},
  {country: "Qatar", code: "+974", countryCode:  "QA"},
  {country: "Oman", code: "+968", countryCode:  "OM"},
  {country: "Nepal", code: "+977", countryCode:  "NP"},
  {country: "Bahrain", code: "+973", countryCode:  "BH"},
  {country: "United States", code: "+1", countryCode:  "US"},
  {country: "Armenia", code: "+374", countryCode:  "AM"},
  {country: "Afghanistan", code: "+93", countryCode:  "AF"},
  {country: "Albania", code: "+355", countryCode:  "AL"},
  {country: "Algeria", code: "+213", countryCode:  "DZ"},
  {country: "American Samoa", code: "+1-684", countryCode:  "AS"},
  {country: "Andorra", code: "+376", countryCode:  "AD"},
  {country: "Angola", code: "+244", countryCode:  "AO"},
  {country: "Anguilla", code: "+1-264", countryCode:  "AI"},
  {country: "Antarctica", code: "+672", countryCode:  "AQ"},
  {country: "Antigua and Barbuda", code: "+1-268", countryCode:  "AG"},
  {country: "Argentina", code: "+54", countryCode:  "AR"},
  {country: "Aruba", code: "+297", countryCode:  "AW"},
  {country: "Australia", code: "+61", countryCode:  "AU"},
  {country: "Austria", code: "+43", countryCode:  "AT"},
  {country: "Azerbaijan", code: "+994", countryCode:  "AZ"},
  {country: "Bahamas", code: "+1-242", countryCode:  "BS"},
  {country: "Barbados", code: "+1-246", countryCode:  "BB"},
  {country: "Belarus", code: "+375", countryCode:  "BY"},
  {country: "Belgium", code: "+32", countryCode:  "BE"},
  {country: "Belize", code: "+501", countryCode:  "BZ"},
  {country: "Benin", code: "+229", countryCode:  "BJ"},
  {country: "Bermuda", code: "+1-441", countryCode:  "BM"},
  {country: "Bhutan", code: "+975", countryCode:  "BT"},
  {country: "Bolivia", code: "+591", countryCode:  "BO"},
  {country: "Bosnia and Herzegovina", code: "+387", countryCode:  "BA"},
  {country: "Botswana", code: "+267", countryCode:  "BW"},
  {country: "Brazil", code: "+55", countryCode:  "BR"},
  {country: "British Indian Ocean Territory", code: "+246", countryCode:  "IO"},
  {country: "British Virgin Islands", code: "+1-284", countryCode:  "VG"},
  {country: "Brunei", code: "+673", countryCode:  "BN"},
  {country: "Bulgaria", code: "+359", countryCode:  "BG"},
  {country: "Burkina Faso", code: "+226", countryCode:  "BF"},
  {country: "Burundi", code: "+257", countryCode:  "BI"},
  {country: "Cambodia", code: "+855", countryCode:  "KH"},
  {country: "Cameroon", code: "+237", countryCode:  "CM"},
  {country: "Canada", code: "+1", countryCode:  "CA"},
  {country: "Cape Verde", code: "+238", countryCode:  "CV"},
  {country: "Cayman Islands", code: "+1-345", countryCode:  "KY"},
  {country: "Central African Republic", code: "+236", countryCode:  "CF"},
  {country: "Chad", code: "+235", countryCode:  "TD"},
  {country: "Chile", code: "+56", countryCode:  "CL"},
  {country: "China", code: "+86", countryCode:  "CN"},
  {country: "Christmas Island", code: "+61", countryCode:  "CX"},
  {country: "Cocos Islands", code: "+61", countryCode:  "CC"},
  {country: "Colombia", code: "+57", countryCode:  "CO"},
  {country: "Comoros", code: "+269", countryCode:  "KM"},
  {country: "Cook Islands", code: "+682", countryCode:  "CK"},
  {country: "Costa Rica", code: "+506", countryCode:  "CR"},
  {country: "Croatia", code: "+385", countryCode:  "HR"},
  {country: "Cuba", code: "+53", countryCode:  "CU"},
  {country: "Curacao", code: "+599", countryCode:  "CW"},
  {country: "Cyprus", code: "+357", countryCode:  "CY"},
  {country: "Czech Republic", code: "+420", countryCode:  "CZ"},
  {country: "Democratic Republic of the Congo", code: "+243", countryCode:  "CD"},
  {country: "Denmark", code: "+45", countryCode:  "DK"},
  {country: "Djibouti", code: "+253", countryCode:  "DJ"},
  {country: "Dominica", code: "+1-767", countryCode:  "DM"},
  {country: "Dominican Republic", code: "+1", countryCode:  "DO"},
  {country: "East Timor", code: "+670", countryCode:  "TL"},
  {country: "Ecuador", code: "+593", countryCode:  "EC"},
  {country: "Egypt", code: "+20", countryCode:  "EG"},
  {country: "El Salvador", code: "+503", countryCode:  "SV"},
  {country: "Equatorial Guinea", code: "+240", countryCode:  "GQ"},
  {country: "Eritrea", code: "+291", countryCode:  "ER"},
  {country: "Estonia", code: "+372", countryCode:  "EE"},
  {country: "Ethiopia", code: "+251", countryCode:  "ET"},
  {country: "Falkland Islands", code: "+500", countryCode:  "FK"},
  {country: "Faroe Islands", code: "+298", countryCode:  "FO"},
  {country: "Fiji", code: "+679", countryCode:  "FJ"},
  {country: "Finland", code: "+358", countryCode:  "FI"},
  {country: "France", code: "+33", countryCode:  "FR"},
  {country: "French Polynesia", code: "+689", countryCode:  "PF"},
  {country: "Gabon", code: "+241", countryCode:  "GA"},
  {country: "Gambia", code: "+220", countryCode:  "GM"},
  {country: "Georgia", code: "+995", countryCode:  "GE"},
  {country: "Germany", code: "+49", countryCode:  "DE"},
  {country: "Ghana", code: "+233", countryCode:  "GH"},
  {country: "Gibraltar", code: "+350", countryCode:  "GI"},
  {country: "Greece", code: "+30", countryCode:  "GR"},
  {country: "Greenland", code: "+299", countryCode:  "GL"},
  {country: "Grenada", code: "+1-473", countryCode:  "GD"},
  {country: "Guam", code: "+1-671", countryCode:  "GU"},
  {country: "Guatemala", code: "+502", countryCode:  "GT"},
  {country: "Guernsey", code: "+44-1481", countryCode:  "GG"},
  {country: "Guinea", code: "+224", countryCode:  "GN"},
  {country: "Guinea-Bissau", code: "+245", countryCode:  "GW"},
  {country: "Guyana", code: "+592", countryCode:  "GY"},
  {country: "Haiti", code: "+509", countryCode:  "HT"},
  {country: "Honduras", code: "+504", countryCode:  "HN"},
  {country: "Hong Kong", code: "+852", countryCode:  "HK"},
  {country: "Hungary", code: "+36", countryCode:  "HU"},
  {country: "Iceland", code: "+354", countryCode:  "IS"},
  {country: "Indonesia", code: "+62", countryCode:  "ID"},
  {country: "Iran", code: "+98", countryCode:  "IR"},
  {country: "Iraq", code: "+964", countryCode:  "IQ"},
  {country: "Ireland", code: "+353", countryCode:  "IE"},
  {country: "Isle of Man", code: "+44-1624", countryCode:  "IM"},
  {country: "Israel", code: "+972", countryCode:  "IL"},
  {country: "Italy", code: "+39", countryCode:  "IT"},
  {country: "Ivory Coast", code: "+225", countryCode:  "CI"},
  {country: "Jamaica", code: "+1-876", countryCode:  "JM"},
  {country: "Japan", code: "+81", countryCode:  "JP"},
  {country: "Jersey", code: "+44-1534", countryCode:  "JE"},
  {country: "Jordan", code: "+962", countryCode:  "JO"},
  {country: "Kazakhstan", code: "+7", countryCode:  "KZ"},
  {country: "Kenya", code: "+254", countryCode:  "KE"},
  {country: "Kiribati", code: "+686", countryCode:  "KI"},
  {country: "Kosovo", code: "+383", countryCode:  "XK"},
  {country: "Kyrgyzstan", code: "+996", countryCode:  "KG"},
  {country: "Laos", code: "+856", countryCode:  "LA"},
  {country: "Latvia", code: "+371", countryCode:  "LV"},
  {country: "Lebanon", code: "+961", countryCode:  "LB"},
  {country: "Lesotho", code: "+266", countryCode:  "LS"},
  {country: "Liberia", code: "+231", countryCode:  "LR"},
  {country: "Libya", code: "+218", countryCode:  "LY"},
  {country: "Liechtenstein", code: "+423", countryCode:  "LI"},
  {country: "Lithuania", code: "+370", countryCode:  "LT"},
  {country: "Luxembourg", code: "+352", countryCode:  "LU"},
  {country: "Macao", code: "+853", countryCode:  "MO"},
  {country: "Macedonia", code: "+389", countryCode:  "MK"},
  {country: "Madagascar", code: "+261", countryCode:  "MG"},
  {country: "Malawi", code: "+265", countryCode:  "MW"},
  {country: "Malaysia", code: "+60", countryCode:  "MY"},
  {country: "Maldives", code: "+960", countryCode:  "MV"},
  {country: "Mali", code: "+223", countryCode:  "ML"},
  {country: "Malta", code: "+356", countryCode:  "MT"},
  {country: "Marshall Islands", code: "+692", countryCode:  "MH"},
  {country: "Mauritania", code: "+222", countryCode:  "MR"},
  {country: "Mauritius", code: "+230", countryCode:  "MU"},
  {country: "Mayotte", code: "+262", countryCode:  "YT"},
  {country: "Mexico", code: "+52", countryCode:  "MX"},
  {country: "Micronesia", code: "+691", countryCode:  "FM"},
  {country: "Moldova", code: "+373", countryCode:  "MD"},
  {country: "Monaco", code: "+377", countryCode:  "MC"},
  {country: "Mongolia", code: "+976", countryCode:  "MN"},
  {country: "Montenegro", code: "+382", countryCode:  "ME"},
  {country: "Montserrat", code: "+1-664", countryCode:  "MS"},
  {country: "Morocco", code: "+212", countryCode:  "MA"},
  {country: "Mozambique", code: "+258", countryCode:  "MZ"},
  {country: "Myanmar", code: "+95", countryCode:  "MM"},
  {country: "Namibia", code: "+264", countryCode:  "NA"},
  {country: "Nauru", code: "+674", countryCode:  "NR"},
  {country: "Netherlands", code: "+31", countryCode:  "NL"},
  {country: "Netherlands Antilles", code: "+599", countryCode:  "AN"},
  {country: "New Caledonia", code: "+687", countryCode:  "NC"},
  {country: "New Zealand", code: "+64", countryCode:  "NZ"},
  {country: "Nicaragua", code: "+505", countryCode:  "NI"},
  {country: "Niger", code: "+227", countryCode:  "NE"},
  {country: "Nigeria", code: "+234", countryCode:  "NG"},
  {country: "Niue", code: "+683", countryCode:  "NU"},
  {country: "North Korea", code: "+850", countryCode:  "KP"},
  {country: "Northern Mariana Islands", code: "+1-670", countryCode:  "MP"},
  {country: "Norway", code: "+47", countryCode:  "NO"},
  {country: "Palau", code: "+680", countryCode:  "PW"},
  {country: "Palestine", code: "+970", countryCode:  "PS"},
  {country: "Panama", code: "+507", countryCode:  "PA"},
  {country: "Papua New Guinea", code: "+675", countryCode:  "PG"},
  {country: "Paraguay", code: "+595", countryCode:  "PY"},
  {country: "Peru", code: "+51", countryCode:  "PE"},
  {country: "Philippines", code: "+63", countryCode:  "PH"},
  {country: "Pitcairn", code: "+64", countryCode:  "PN"},
  {country: "Poland", code: "+48", countryCode:  "PL"},
  {country: "Portugal", code: "+351", countryCode:  "PT"},
  {country: "Puerto Rico", code: "+1", countryCode:  "PR"},
  {country: "Republic of the Congo", code: "+242", countryCode:  "CG"},
  {country: "Reunion", code: "+262", countryCode:  "RE"},
  {country: "Romania", code: "+40", countryCode:  "RO"},
  {country: "Russia", code: "+7", countryCode:  "RU"},
  {country: "Rwanda", code: "+250", countryCode:  "RW"},
  {country: "Saint Barthelemy", code: "+590", countryCode:  "BL"},
  {country: "Saint Helena", code: "+290", countryCode:  "SH"},
  {country: "Saint Kitts and Nevis", code: "+1-869", countryCode:  "KN"},
  {country: "Saint Lucia", code: "+1-758", countryCode:  "LC"},
  {country: "Saint Martin", code: "+590", countryCode:  "MF"},
  {country: "Saint Pierre and Miquelon", code: "+508", countryCode:  "PM"},
  {country: "Saint Vincent and the Grenadines", code: "+1-784", countryCode:  "VC"},
  {country: "Samoa", code: "+685", countryCode:  "WS"},
  {country: "San Marino", code: "+378", countryCode:  "SM"},
  {country: "Sao Tome and Principe", code: "+239", countryCode:  "ST"},
  {country: "Senegal", code: "+221", countryCode:  "SN"},
  {country: "Serbia", code: "+381", countryCode:  "RS"},
  {country: "Seychelles", code: "+248", countryCode:  "SC"},
  {country: "Sierra Leone", code: "+232", countryCode:  "SL"},
  {country: "Singapore", code: "+65", countryCode:  "SG"},
  {country: "Sint Maarten", code: "+1-721", countryCode:  "SX"},
  {country: "Slovakia", code: "+421", countryCode:  "SK"},
  {country: "Slovenia", code: "+386", countryCode:  "SI"},
  {country: "Solomon Islands", code: "+677", countryCode:  "SB"},
  {country: "Somalia", code: "+252", countryCode:  "SO"},
  {country: "South Africa", code: "+27", countryCode:  "ZA"},
  {country: "South Korea", code: "+82", countryCode:  "KR"},
  {country: "South Sudan", code: "+211", countryCode:  "SS"},
  {country: "Spain", code: "+34", countryCode:  "ES"},
  {country: "Sri Lanka", code: "+94", countryCode:  "LK"},
  {country: "Sudan", code: "+249", countryCode:  "SD"},
  {country: "Suriname", code: "+597", countryCode:  "SR"},
  {country: "Svalbard and Jan Mayen", code: "+47", countryCode:  "SJ"},
  {country: "Swaziland", code: "+268", countryCode:  "SZ"},
  {country: "Sweden", code: "+46", countryCode:  "SE"},
  {country: "Switzerland", code: "+41", countryCode:  "CH"},
  {country: "Syria", code: "+963", countryCode:  "SY"},
  {country: "Taiwan", code: "+886", countryCode:  "TW"},
  {country: "Tajikistan", code: "+992", countryCode:  "TJ"},
  {country: "Tanzania", code: "+255", countryCode:  "TZ"},
  {country: "Thailand", code: "+66", countryCode:  "TH"},
  {country: "Togo", code: "+228", countryCode:  "TG"},
  {country: "Tokelau", code: "+690", countryCode:  "TK"},
  {country: "Tonga", code: "+676", countryCode:  "TO"},
  {country: "Trinidad and Tobago", code: "+1-868", countryCode:  "TT"},
  {country: "Tunisia", code: "+216", countryCode:  "TN"},
  {country: "Turkmenistan", code: "+993", countryCode:  "TM"},
  {country: "Turks and Caicos Islands", code: "+1-649", countryCode:  "TC"},
  {country: "Tuvalu", code: "+688", countryCode:  "TV"},
  {country: "U.S. Virgin Islands", code: "+1-340", countryCode:  "VI"},
  {country: "Uganda", code: "+256", countryCode:  "UG"},
  {country: "Ukraine", code: "+380", countryCode:  "UA"},
  {country: "United Kingdom", code: "+44", countryCode:  "GB"},
  {country: "Uruguay", code: "+598", countryCode:  "UY"},
  {country: "Uzbekistan", code: "+998", countryCode:  "UZ"},
  {country: "Vanuatu", code: "+678", countryCode:  "VU"},
  {country: "Vatican", code: "+379", countryCode:  "VA"},
  {country: "Venezuela", code: "+58", countryCode:  "VE"},
  {country: "Vietnam", code: "+84", countryCode:  "VN"},
  {country: "Wallis and Futuna", code: "+681", countryCode:  "WF"},
  {country: "Western Sahara", code: "+212", countryCode:  "EH"},
  {country: "Yemen", code: "+967", countryCode:  "YE"},
  {country: "Zambia", code: "+260", countryCode:  "ZM"},
  {country: "Zimbabwe", code: "+263", countryCode:  "ZW"}
];

export const AFRICAN_COUNTRIES = [
  { country: "Algeria", code: "+213", countryCode: "DZ" },
  { country: "Angola", code: "+244", countryCode: "AO" },
  { country: "Benin", code: "+229", countryCode: "BJ" },
  { country: "Botswana", code: "+267", countryCode: "BW" },
  { country: "Burkina Faso", code: "+226", countryCode: "BF" },
  { country: "Burundi", code: "+257", countryCode: "BI" },
  { country: "Cabo Verde", code: "+238", countryCode: "CV" },
  { country: "Cameroon", code: "+237", countryCode: "CM" },
  { country: "Central African Republic", code: "+236", countryCode: "CF" },
  { country: "Chad", code: "+235", countryCode: "TD" },
  { country: "Comoros", code: "+269", countryCode: "KM" },
  { country: "Congo (Congo-Brazzaville)", code: "+242", countryCode: "CG" },
  { country: "Congo (Congo-Kinshasa)", code: "+243", countryCode: "CD" },
  { country: "Côte d'Ivoire", code: "+225", countryCode: "CI" },
  { country: "Djibouti", code: "+253", countryCode: "DJ" },
  { country: "Egypt", code: "+20", countryCode: "EG" },
  { country: "Equatorial Guinea", code: "+240", countryCode: "GQ" },
  { country: "Eritrea", code: "+291", countryCode: "ER" },
  { country: "Eswatini", code: "+268", countryCode: "SZ" },
  { country: "Ethiopia", code: "+251", countryCode: "ET" },
  { country: "Gabon", code: "+241", countryCode: "GA" },
  { country: "Gambia", code: "+220", countryCode: "GM" },
  { country: "Ghana", code: "+233", countryCode: "GH" },
  { country: "Guinea", code: "+224", countryCode: "GN" },
  { country: "Guinea-Bissau", code: "+245", countryCode: "GW" },
  { country: "Kenya", code: "+254", countryCode: "KE" },
  { country: "Lesotho", code: "+266", countryCode: "LS" },
  { country: "Liberia", code: "+231", countryCode: "LR" },
  { country: "Libya", code: "+218", countryCode: "LY" },
  { country: "Madagascar", code: "+261", countryCode: "MG" },
  { country: "Malawi", code: "+265", countryCode: "MW" },
  { country: "Mali", code: "+223", countryCode: "ML" },
  { country: "Mauritania", code: "+222", countryCode: "MR" },
  { country: "Mauritius", code: "+230", countryCode: "MU" },
  { country: "Morocco", code: "+212", countryCode: "MA" },
  { country: "Mozambique", code: "+258", countryCode: "MZ" },
  { country: "Namibia", code: "+264", countryCode: "NA" },
  { country: "Niger", code: "+227", countryCode: "NE" },
  { country: "Nigeria", code: "+234", countryCode: "NG" },
  { country: "Rwanda", code: "+250", countryCode: "RW" },
  { country: "São Tomé and Príncipe", code: "+239", countryCode: "ST" },
  { country: "Senegal", code: "+221", countryCode: "SN" },
  { country: "Seychelles", code: "+248", countryCode: "SC" },
  { country: "Sierra Leone", code: "+232", countryCode: "SL" },
  { country: "Somalia", code: "+252", countryCode: "SO" },
  { country: "South Africa", code: "+27", countryCode: "ZA" },
  { country: "South Sudan", code: "+211", countryCode: "SS" },
  { country: "Sudan", code: "+249", countryCode: "SD" },
  { country: "Tanzania", code: "+255", countryCode: "TZ" },
  { country: "Togo", code: "+228", countryCode: "TG" },
  { country: "Tunisia", code: "+216", countryCode: "TN" },
  { country: "Uganda", code: "+256", countryCode: "UG" },
  { country: "Zambia", code: "+260", countryCode: "ZM" },
  { country: "Zimbabwe", code: "+263", countryCode: "ZW" }
];

export const indianRegionMap = {
  AN: "Andaman and Nicobar Islands",
  AP: "Andhra Pradesh",
  AR: "Arunachal Pradesh",
  AS: "Assam",
  BR: "Bihar",
  CH: "Chandigarh",
  CT: "Chhattisgarh",
  DH: "Dadra and Nagar Haveli and Daman and Diu",
  DL: "Delhi",
  GA: "Goa",
  GJ: "Gujarat",
  HR: "Haryana",
  HP: "Himachal Pradesh",
  JK: "Jammu and Kashmir",
  JH: "Jharkhand",
  KA: "Karnataka",
  KL: "Kerala",
  LA: "Ladakh",
  LD: "Lakshadweep",
  MP: "Madhya Pradesh",
  MH: "Maharashtra",
  MN: "Manipur",
  ML: "Meghalaya",
  MZ: "Mizoram",
  NL: "Nagaland",
  OR: "Odisha",
  PB: "Punjab",
  PY: "Puducherry",
  RJ: "Rajasthan",
  SK: "Sikkim",
  TN: "Tamil Nadu",
  TG: "Telangana",
  TR: "Tripura",
  UP: "Uttar Pradesh",
  UT: "Uttarakhand",
  WB: "West Bengal"
};

